module.exports = __webpack_public_path__ + "img/default-product.d44fdc0d.png";